<template>
  <div
    class="slider-box"
    :class="rangeStatus?'success':''"
  >
    <span
      ref="sliderBtn"
      class="slider-btn"
      @mousedown="rangeMove"
    >
      <slot
        v-if="!rangeStatus"
        name="startIcon"
      >
        <i
          class="iconfont icon-iconfont-5"
          style="font-size: 26px"
        ></i>
        <i
          class="iconfont icon-arrow-2-right"
          style="font-size: 20px;padding-left: 8px"
        ></i>
      </slot>
      <slot
        v-if="rangeStatus"
        name="successIcon"
      >
        <Icon type="md-checkmark" />
      </slot>
    </span>
    {{ rangeStatus?successText:startText }}
  </div>
</template>

<script>
export default {
  props: {
    // 成功之后的函数
    successFun: {
      type: Function,
    },

    // 成功文字
    successText: {
      type: String,
      default: '验证成功',
    },
    // 开始的文字
    startText: {
      type: String,
      default: '拖动滑块到最右边',
    },
    // 失败之后的函数
    errorFun: {
      type: Function,
    },
    // value验证是否通过
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disX: 0,
      rangeStatus: this.value,
    };
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        const ele = this.$refs.sliderBtn;
        this.rangeStatus = false;
        ele.style.transition = '.5s all';
        ele.style.transform = 'translateX(0)';
      }
    },
  },
  methods: {
    // 滑块移动
    rangeMove(e) {
      const ele = this.$refs.sliderBtn;
      const startX = e.clientX;
      const eleWidth = ele.offsetWidth;
      const parentWidth = ele.parentElement.offsetWidth;
      const MaxX = parentWidth - eleWidth;
      if (this.rangeStatus) { // 不运行
        return false;
      }
      document.onmousemove = (event) => {
        const endX = event.clientX;
        this.disX = endX - startX;
        if (this.disX <= 0) {
          this.disX = 0;
        }
        if (this.disX >= MaxX - eleWidth) { // 减去滑块的宽度,体验效果更好
          this.disX = MaxX;
        }
        ele.style.transform = `translateX(${ this.disX }px)`;
        event.preventDefault();
      };
      document.onmouseup = () => {
        if (this.disX !== MaxX) {
          ele.style.transition = '.5s all';
          ele.style.transform = 'translateX(0)';
        } else {
          this.rangeStatus = true;
        }
        this.$emit('input', this.rangeStatus);
        // 取法表单验证
        // this.dispatch('FormItem', 'on-form-blur', this.rangeStatus);
        this.dispatch('FormItem', 'on-form-change', this.rangeStatus);
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
};
</script>

<style scoped lang="less">
    .slider-box {
        background-color: #e8eaec;
        position: relative;
        transition: 1s all;
        color: #333;
        text-align: center;
        border:1px solid #dcdee2;
        border-radius: 4px;
        overflow: hidden;
        &.success {
            /*background-color: #3e76f8;*/
            /*color: #fff;*/

            .slider-btn {
                color: #3e76f8;
            }
        }

        .slider-btn{
            transition:.1s all;
            position: absolute;
            left: 0;
            width: 80px;
            height: 100%;
            color: #919191;
            background-color: #fff;
            /*border: 1px solid #bbb;*/
            cursor: pointer;
            text-align: center;
            vertical-align: middle;
        }
    }

</style>
